import React from 'react';
import { IonCard, IonChip, IonCol, IonGrid, IonItem, IonLabel, IonRow, IonIcon, IonBadge } from '@ionic/react';
import useNavigation from '../hooks/useNavigation';
import { makeCall } from '../hooks/common';
import { navigate, pulseOutline, bugOutline, locationOutline, personOutline, call } from 'ionicons/icons';
import "./FarmCard.css"

interface IProps {
    farm: any;
}

const FarmCard: React.FC<IProps> = (props) => {
    const navigateTo = useNavigation();
    function showSensorData( plot: any) {
        navigateTo('/sensor-data', { plot: plot, sinceHours: 24 });
    }

    function showObservationData(plot: any){
        const plotId = plot.plotId || plot._id;
        navigateTo('/add-disease-pest-observation', { plotId });
    }

    return (
        <>
            <IonCard onClick={() => navigateTo('/tabs/farm', { farmId: props.farm.farmId })} style={{ margin: '8px', borderRadius: '12px' }}>
                {/* Header with Farm Name and Plots Count */}
                <IonItem style={{ '--background': 'transparent', '--border-color': 'transparent' }}>
                    <IonLabel>
                        <h2 style={{ fontWeight: 'bold', fontSize: '16px', margin: '0' }}>
                            {props.farm.name || 'Unnamed Farm'}
                        </h2>
                    </IonLabel>
                    <IonBadge color="primary" style={{ fontSize: '12px' }}>
                        {props.farm.plots?.length || 0} Plots
                    </IonBadge>
                </IonItem>

                {/* Main Content Grid */}
                <IonGrid style={{ padding: '0 16px 16px 16px' }}>
                    <IonRow>
                        {/* Left Column - Farm & User Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* User Info */}
                            <div style={{ marginBottom: '12px' }}>
                                {props.farm.farmUser?.name && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <IonIcon icon={personOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                        <span style={{ fontSize: '14px' }}>
                                            {props.farm.farmUser.name}
                                            {props.farm.farmUser?.mobile && (
                                                <IonIcon 
                                                    icon={call} 
                                                    onClick={e => { e.stopPropagation(); makeCall(e as any, props.farm.farmUser?.mobile) }}
                                                    style={{ fontSize: '16px', marginLeft: '8px', color: '#3880ff' }}
                                                />
                                            )}
                                        </span>
                                    </div>
                                )}
                            </div>

                            {/* Location Info */}
                            <div style={{ marginBottom: '12px' }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <IonIcon icon={locationOutline} style={{ fontSize: '16px', marginRight: '8px', color: '#666' }} />
                                    <span style={{ fontSize: '14px' }}>
                                        {props.farm.place}{props.farm.taluka ? ', ' + props.farm.taluka : ''}{props.farm.district ? ', ' + props.farm.district : ''}
                                    </span>
                                </div>
                            </div>
                        </IonCol>

                        {/* Right Column - Plots Info */}
                        <IonCol size="12" sizeMd="6">
                            {/* Plots List */}
                            <IonGrid>
                                <IonRow>
                                    {props.farm.plots?.length > 0 && props.farm.plots.map((item: any, index: number) =>
                                        <IonCol key={index}>
                                            <IonChip outline={true} color="primary" style={{maxWidth: '90%'}}>
                                                <>
                                                <IonLabel onClick={e => { e.stopPropagation(); navigateTo('/tabs/plot', { plotId: item.plotId }) }}>
                                                    {item.plotId.length > 20 ? `${item.plotId.substring(0, 20)}...` : item.plotId}
                                                </IonLabel>
                                                <IonIcon className="iconContainer" icon={bugOutline} onClick={e=>{e.stopPropagation();showObservationData(item)}}></IonIcon>
                                                <IonIcon  className="iconContainer"  icon={pulseOutline} onClick={e=>{e.stopPropagation();showSensorData(item)}}></IonIcon>
                                                </>
                                            </IonChip>
                                        </IonCol>
                                    )}
                                    {(!props.farm.plots || props.farm.plots.length === 0) && (
                                        <IonCol><IonLabel class="secondary-text">No Plots Found</IonLabel></IonCol>
                                    )}
                                </IonRow>
                            </IonGrid>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonCard>
        </>
    );
};

export default FarmCard;
